export { CapitalizationEditModal } from './CapitalizationEditModal';
